"use strict";
import React from "react";
import ReactUtils from "../../react_utils";
import _ from "underscore";
import format from "../../formatters/general";
var bem = ReactUtils.makeBem("carrier-payable-chooser");
function renderEditableEmpty() {
  return /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement("i", { className: bem("__warning-icon") + " fi-alert" }), /* @__PURE__ */ React.createElement("div", { className: bem("__warning-text") }, "Carrier payable not found: Carrier payable will need to be created in TMS to proceed."));
}
function renderUneditableNone() {
  return /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement("div", { className: bem("__warning-text") }, "No linked payable"));
}
function total(props, carrierPayable) {
  return _.chain(props.lineItems).filter((li) => li.tms_carrier_payable_id == carrierPayable.id).map((li) => parseFloat(li.total)).compact().reduce((memo, num) => memo + num, 0).value();
}
function renderDropdown(props, validCarrierPayables) {
  const placeholderDefaultVal = "placeholderDefaultVal";
  const notaVal = "notaVal";
  const currentVal = props.currentCarrierPayableId || placeholderDefaultVal;
  const options = validCarrierPayables.map(
    (payable) => payableToOption(props, payable)
  );
  return /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement(
    "select",
    {
      defaultValue: String(currentVal),
      onChange: props.onChange,
      disabled: !props.allowsEditing
    },
    /* @__PURE__ */ React.createElement("option", { value: placeholderDefaultVal, disabled: true }, "Select a carrier payable for this invoice"),
    options,
    /* @__PURE__ */ React.createElement("option", { value: notaVal }, "None of the above")
  ));
}
function payableToOption(props, payable) {
  let title = payable.external_id ? `<Carrier payable #${payable.external_id}>` : `<Carrier payable>`;
  if (props.carrierInvoice != null && payable.carrier_invoice_id && payable.carrier_invoice_id != props.carrierInvoice.id) {
    title = `[LINKED] ${title}`;
  }
  const totalStr = `Total amount ${format.currency(total(props, payable))}`;
  const status = payable.status ? `(${payable.status})` : "";
  const content = `${title} ${totalStr} ${status}`;
  return /* @__PURE__ */ React.createElement("option", { key: payable.id, value: payable.id }, content);
}
export default function CarrierPayableChooser(props) {
  const validCarrierPayables = props.carrierPayables.filter((payable) => {
    return payable.tms_carrier_id == props.carrier.id;
  });
  if (props.allowsEditing) {
    if (validCarrierPayables.length == 0) {
      return renderEditableEmpty();
    } else {
      return renderDropdown(props, validCarrierPayables);
    }
  } else {
    if (props.currentCarrierPayableId) {
      return renderDropdown(props, validCarrierPayables);
    } else {
      return renderUneditableNone();
    }
  }
}
